import { MdOutlineCancel } from 'react-icons/md';
import Select from 'react-select';
import { ContainerOnRemove } from './styles';
import { colors } from '../../styles/tokens';

const SelectForm = ({ options, value, onChange, label, error, isDisabled, onRemove = false, ...props }) => {
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            border: '1px solid rgba(255, 255, 255, 0.06)',
            backgroundColor: 'rgba(255, 255, 255, 0.06)',
            borderRadius: '12px',
            width: '100%',
            padding: '4px 16px',
            boxShadow: 'none',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.6 : 1,
            minHeight: "48px"
        }),
        input: (provided) => ({
            ...provided,
            color: isDisabled ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 1)',
            background: 'transparent',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDisabled ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 1)',
            background: 'transparent',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? colors.primary : state.isFocused ? 'rgba(255, 255, 255, 0.06)' : 'transparent',
            color: '#fff',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '4px',
            color: 'white',
            padding: '2px 6px',
        }),
        MultiValueGeneric: (provided) => ({
            ...provided,
            color: "white"
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: 'white',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0',
        }),
        menu: (provided) => ({
            ...provided,
            background: 'rgba(30, 30, 30, 0.95)',
            border: '1px solid rgba(255, 255, 255, 0.06)',
            borderRadius: '12px',
            backdropFilter: 'blur(10px)',
            overflow: 'hidden',
            zIndex: 9999,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        container: (provided) => ({
            ...provided,
            width: "100%"
        })
    };

    // const handleSelectChange = (selectedOption) => {
    //     onChange(selectedOption.value);
    // };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <div style={{ display: 'flex', alignItems: 'center', padding: "0px 16px", gap: "10px" }}>
                {label && <label style={{ color: '#fff', fontSize: "14px" }}>{label}</label>}
                {error && <p style={{ color: 'red', fontSize: '0.8em' }}>{error}</p>}
            </div>
            <ContainerOnRemove>
                <Select
                    {...props}
                    options={options}
                    value={value}
                    onChange={onChange}
                    styles={customStyles}
                    isDisabled={isDisabled}
                    menuPortalTarget={document.body}
                />

                {onRemove && (
                    <button
                        type="button"
                        onClick={onRemove}
                    >
                        <MdOutlineCancel size={24} color="rgba(247, 6, 6, 1)" />
                    </button>
                )}
            </ContainerOnRemove>
        </div>

    );
}

export default SelectForm;
